import { Permission } from 'api/PermissionsAPI';
import { Role } from 'api/RolesAPI';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { User } from 'modules/graphql';

export enum Alignment {
  FLEX_START = 'flex-start',
  CENTER = 'center',
  FLEX_END = 'flex-end',
}

export type Column = {
  /** Align header content using flex properties: flex-start | center | flex-end */
  alignment?: Alignment;
  /** value used to determine which column is sorted */
  id: string;
  /** display value for column */
  label: string;
  /** determine if column should be able to be sorted */
  isSortable?: boolean;
};

export type TableHeaderProps = {
  /** columns to display */
  columns: Column[];
  /** string value for display grid `grid-template-columns` */
  gridLayout: string;
  /** key to sort rows on based on Column.id */
  sortBy: string;
  /** Direction to sort items ascending | descending */
  sortDirection: SORT_DIRECTIONS;
  /** Function run when sortBy value is changed */
  onSortByChange: (newSortedById: string) => void;
  /** Function run when sort direction is changed */
  onSortDirectionChange: (sortDirection: SORT_DIRECTIONS) => void;
};

/**
 * Members
 */
export type FormattedMembers = {
  projectMemberships: {
    [key: string]: string[];
  };
  teamMemberships: {
    [key: string]: string[];
  };
  orgAdmins: string[];
};

/**
 * Permissions
 */
export type Categories = {
  [key: string]: {
    id: string;
    name: string;
    permissions: number[];
  };
};

type PermissionDetails = {
  /** List of related permssions as a parent/child relationship */
  children?: number[];
  /** Text description used to message to user more details */
  description: string;
  /** Text displayed for the permission by the checkbox */
  name: string;
};

export type MergedPermission = Permission &
  PermissionDetails & {
    /** Adds relationship to permssions that require another */
    requiredBy: number[];
  };

export type PermissionsById = {
  [key: string]: MergedPermission;
};

export type PermissionsMapKey = {
  [key: string]: PermissionDetails;
};

/**
 * Roles
 */
export type CombinedRole = Role & {
  scope: string;
  members: string[];
};

/**
 * Users types
 */
export type UsersResponse = {
  isLoadingUsers: boolean;
  refetchUsers: () => void;
  users: User[];
};

/**
 * UI
 */
export type Category = {
  id: string;
  name: string;
  permissions: number[];
};

export type Group = {
  name: string;
  categories: Category[];
};
